import { MASCOT } from "./brand";

const info = [
    { k: "会社名", v: "株式会社フレッシュエージェント" },
    { k: "事業名", v: "やさまる電電開発" },
    { k: "事業内容", v: "業務改善Webアプリの企画・開発・運用支援" },
    { k: "対応領域", v: "勤怠 / シフト / 受発注 / 顧客管理 / 売上分析 ほか" },
];

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 sm:py-32 bg-white overflow-hidden"
        >
            <div
                aria-hidden
                className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#F0F7E8] blur-3xl opacity-60"
            />

            <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-6">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#C8E0AC] text-xs font-bold tracking-widest uppercase text-[#4A7A2F]">
                        OUR MISSION — 私たちの想い
                    </div>
                    <h2
                        data-testid="about-title"
                        className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1F2A23] leading-[1.15]"
                    >
                        世界をもっと、
                        <br />
                        <span className="text-[#7DB856]">やさしく</span>、
                        <span className="text-[#7DB856]">まるく</span>、しよう。
                    </h2>
                    <p className="mt-6 text-base sm:text-lg text-[#5C6B5E] leading-relaxed max-w-xl">
                        やさまる電電開発は、株式会社フレッシュエージェントが運営する業務改善Webアプリの開発チームです。「IT＝難しい」を、「IT＝やさしい」に。
                        <br />
                        現場のひとつひとつの困りごとを、まあるく解いていく。
                        私たちは、そんな小さな積み重ねが、世界をやさしくすると信じています。
                    </p>

                    <dl className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {info.map((i) => (
                            <div
                                key={i.k}
                                data-testid={`about-info-${i.k}`}
                                className="rounded-2xl bg-[#FAFCF5] border border-[#E6EFD8] p-4"
                            >
                                <dt className="text-[10px] font-bold tracking-widest uppercase text-[#8A9690]">
                                    {i.k}
                                </dt>
                                <dd className="mt-1 text-sm font-extrabold text-[#2F5F1A]">
                                    {i.v}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>

                <div className="lg:col-span-6">
                    <div className="relative max-w-md mx-auto">
                        <div className="aspect-square rounded-[40%] bg-gradient-to-br from-[#F0F7E8] via-[#FFF6E0] to-[#E6F2D6] flex items-center justify-center overflow-hidden border border-[#E6EFD8] shadow-soft">
                            <img
                                src={MASCOT.smileClosedEyes}
                                alt="やさまるくん"
                                className="w-[80%] h-[80%] object-contain"
                                draggable={false}
                            />
                        </div>
                        {/* floating tags */}
                        <div className="absolute -top-4 -left-2 bg-white rounded-2xl border border-[#E6EFD8] shadow-soft px-4 py-2 animate-float">
                            <div className="text-[10px] font-bold text-[#8A9690]">創業</div>
                            <div className="font-extrabold text-[#2F5F1A]">2020年</div>
                        </div>
                        <div className="absolute -bottom-4 -right-2 bg-white rounded-2xl border border-[#E6EFD8] shadow-soft px-4 py-2 animate-float-rev">
                            <div className="text-[10px] font-bold text-[#8A9690]">所在地</div>
                            <div className="font-extrabold text-[#2F5F1A]">日本 🇯🇵</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
